import {
	hideOverflows,
	restoreOverflows,
} from 'utils/overflowControl/overflowControl'

import {
	hideFromScreenReaders,
	restoreForScreenReaders,
} from './screenReaderVisibility'

export const changeMarkupOnShow = (): void => {
	hideOverflows()
	hideFromScreenReaders()
}

export const changeMarkupOnHide = (): void => {
	restoreOverflows()
	restoreForScreenReaders()
}
